import { isRRAEmailAddress } from "../../models/user";
import { ExecProjectPlatformType } from "../../types/agent-pipelines";

export type RaasProjectPlatformType =
  | ExecProjectPlatformType.RRA
  | ExecProjectPlatformType.RaaS;

export const getRaasExecProjectPlatformType = ({
  currentUserIsRra,
  isTargetUserImpersonation,
  targetUserEmail,
}: {
  currentUserIsRra: boolean;
  isTargetUserImpersonation: boolean;
  targetUserEmail: string | undefined;
}): RaasProjectPlatformType => {
  if (isTargetUserImpersonation) {
    return isRRAEmailAddress(targetUserEmail)
      ? ExecProjectPlatformType.RRA
      : ExecProjectPlatformType.RaaS;
  }

  return currentUserIsRra
    ? ExecProjectPlatformType.RRA
    : ExecProjectPlatformType.RaaS;
};
